<script>
  import { createEventDispatcher } from "svelte";
  import { ChevronDownIcon } from "svelte-feather-icons";

  export let quantity;

  const dispatch = createEventDispatcher();

  let dropdown = false;
  let quantityContainer;

  document.addEventListener("mouseup", function (e) {
    e.stopPropagation();

    let container = jQuery(quantityContainer);
    
    if (container.has(e.target).length === 0) {
      dropdown = false;
    }
  });

  function handleChange(_quantity) {
    if (_quantity === "" || _quantity === 0) {
      return;
    }

    dropdown = false;
    quantity = _quantity;
    dispatch('change', _quantity);
  }
</script>

<style lang="scss">
  .cart__product-quantity {
    margin-right: 15px;

    p {
      margin-bottom: 0;
      font-size: 12px;
    }

    &-dropdown {
      position: absolute;
      width: 14px;
      cursor: pointer;
      height: 14px;
      right: 5px;
      top: 0;
      bottom: 0;
      margin: auto;
      line-height: 0;

      :global(svg) {
        width: 100%;
        height: 100%;
      }

      &__select {
        position: absolute;
        width: 100%;
        height: auto;
        z-index: 1231321;
        border: 1px solid #1081c4;
        background: #fff;

        div {
          padding-left: 5px;
          padding-right: 5px;

          &:hover {
            color: #fff;
            background: #1081c4;
          }
        }
      }
    }

    &-wrapper {
      position: relative;

      input {
        width: 50px;
        padding: 3px 5px;
        font-size: 14px;
      }
    }
  }
</style>

<div class="cart__product-quantity" bind:this={quantityContainer}>
  <p>Aantal:</p>
  <div class="cart__product-quantity-wrapper">
    <input
      type="text"
      bind:value={quantity}
      on:keyup={e => handleChange(e.target.value)} />

    <span
      class="cart__product-quantity-dropdown"
      on:click={() => (dropdown = !dropdown)}>
      <!-- <ChevronDownIcon /> -->
    </span>

    {#if dropdown}
      <div class="cart__product-quantity-dropdown__select">
        <div on:click|stopPropagation={() => handleChange(1)}>1</div>
        <div on:click|stopPropagation={() => handleChange(2)}>2</div>
        <div on:click|stopPropagation={() => handleChange(3)}>3</div>
        <div on:click|stopPropagation={() => handleChange(4)}>4</div>
        <div on:click|stopPropagation={() => handleChange(5)}>5</div>
        <div on:click|stopPropagation={() => handleChange(6)}>6</div>
        <div on:click|stopPropagation={() => handleChange(7)}>7</div>
        <div on:click|stopPropagation={() => handleChange(8)}>8</div>
        <div on:click|stopPropagation={() => handleChange(9)}>9</div>
        <div on:click|stopPropagation={() => handleChange(10)}>10</div>
      </div>
    {/if}
  </div>
</div>
